
import Request from './request';

async function fetch(data) {
    return Request('get', "api/sub-account-settings", data);
}

async function fetchOne(type) {// 获取单个
    return Request('get', "api/sub-account-settings/?type=" + type);
}

async function fetchAll() {
    return Request('get', "api/sub-account-settings");
}

async function del(type) {
    return Request('delete', 'api/sub-account-settings/delete/' + type)
}

// 新增 编辑 保存
async function save(type, data) {
    if (type) {
        return Request('post', 'api/sub-account-settings/edit/' + type, data);
    } else {
        return Request('post', 'api/sub-account-settings/add', data)
    }
}

// 网商分账保存
async function saveWsSetting(data) {
    return Request('post', 'api/sub-account-settings/ws-bank-setting', data);
}

// 建行分账保存
async function saveCCBSetting(data) {
    return Request('post', 'api/sub-account-settings/ccb-scan-setting', data);
}

// 拉卡拉分账保存
async function saveLKLSetting(data) {
    return Request('post', 'api/sub-account-settings/lkl-setting', data);
}



export default {
    fetch,
    fetchOne,
    fetchAll,
    del,
    save,
    saveWsSetting,
    saveCCBSetting,
    saveLKLSetting,
};